export const cardParams = {
  'cc-number': {
    visible: true,
    text: 'Card Number',
    attr: {
      placeholder: 'Card Number',
      required: 'true',
      autoComplete: 'cc-number',
      inputmode: 'numeric',
      mask: [
        {
          mask: '0000 0000 0000 0000',
          cardType: '',
          maxLength: 19,
        },
        {
          mask: '0000 000000 00000',
          cardType: 'amex',
          maxLength: 17,
        },
      ],
      name: 'cardnumber',
    },
  },
  'cc-cvv': {
    visible: true,
    text: 'CVV',
    columnInLine: 3,
    attr: {
      placeholder: 'CVV',
      required: 'true',
      inputmode: 'numeric',
      autocomplete: 'current-password',
      mask: [
        {
          mask: '000',
          cardType: '',
          maxLength: 3,
        },
        {
          mask: '0000',
          cardType: 'amex',
          maxLength: 4,
        },
      ],
      name: 'cvc',
    },
  },
  'cc-expiry': {
    visible: true,
    columnInLine: 3,
    text: 'Exp. Date',
    attr: {
      required: 'true',
      autocomplete: 'cc-exp',
      inputmode: 'numeric',
      maxlength: '7',
      'data-year-symbols': '4',
      mask: '00/0000',
      name: 'cc-exp',
      placeholder: 'MM/YYYY',
    },
  },
  'cc-zip': {
    visible: true,
    text: 'Zip',
    columnInLine: 3,
    attr: {
      placeholder: 'Zip',
      required: 'true',
      autocomplete: 'postal-code',
      maxlength: '5',
      name: 'cc-zip',
    },
  },
};

export const dividerObj = {
  dividerStyles:
    'background: url(https://cdn.release.gocurb.com/img/cards-icon.png) no-repeat center center; background-size: contain;width: 75%; height: 36px; border: none; text-align: center; margin: 25px 0 0;',
};

export const applePayObj = {
  isApplePay: true,
  isTokenizationRequest: true,
  containerStyles: 'text-align: center; margin-top: 25px;',
  buttonStyles:
    'background: url(https://cdn.gocurb.com/img/artboard.svg) no-repeat 0 0; background-size: cover; width: 100%; height: 46px; border: none; cursor: pointer',
  buttonText: '',
};

export const payPalObj = {
  isPayPalPay: true,
  containerStyles: 'text-align: center; margin-top: 25px;',
  buttonStyles:
    'background: url(https://cdn.gocurb.com/img/pay_pal.svg) no-repeat 0 0; background-size: cover;width: 100%; height: 46px; border: none; cursor: pointer',
  buttonText: '',
};

export const countriesObj = {
  customDropdownFunctionality: true,
  labelName: 'Country',
  containerStyles: 'display: flex; width: 100%; position: relative; flex-direction: column; margin-bottom: 25px;',
  labelStyles:
    'color: #707070; font-size: 14px; background: #fff; position: absolute; left: 12px; top: -8px; z-index: 10; padding: 0 4px;',
  buttonStyles:
    '-webkit-appearance: none; -moz-appearance: none; appearance: none; box-shadow: none; position: relative; border-radius: 4px; border: 2px solid #c6c8ca; background: transparent; padding: 16px 40px 16px 45px; outline: none; color: #404040; font-size: 18px; margin: 0; width: 100%; display: block; box-sizing: border-box; text-align: left; cursor: pointer; background: url(https://cdn.release.gocurb.com/img/arrowdrop-down.svg) no-repeat 96% center;',
  listStyles: 'display: none; list-style: none; padding: 0; margin: 0;',
  itemStyles:
    'font-size: 16px; line-height: 22px; color: #444444; border-bottom: 2px solid #ecf0f3; padding: 16px; background: #fff',
  spanStyles: 'position: absolute; top: 21px; left: 13px',
  countries: {
    US: {
      id: 'us',
      name: 'United States',
      selected: true,
    },
    GB: {
      id: 'gb',
      name: 'United Kingdom',
      selected: false,
    },
    CA: {
      id: 'ca',
      name: 'Canada',
      selected: false,
    },
  },
};

const inlineStyles =
  '<style>' +
  'body {font-family: Roboto, sans-serif!important; margin: 0!important; padding: 0!important;}' +
  '.text-center {text-align: center!important;}' +
  '.form-inner-container .form-group {width: 100%}' +
  '.form-inner-container .form-group.cc-cvv-field {margin-right: 0!important;}' +
  '.form-inner-container .form-group.filled .form-label {display: block!important;}' +
  '.form-input:focus {border-color: #0f8560!important; cursor: text;}' +
  '.form-input::-webkit-input-placeholder {color: #707070;}' +
  '.form-input.disabled {background: rgba(239, 239, 239, 0.5)!important;}' +
  '.error-group .form-label {color: #cf3636!important;}' +
  '.error-group .form-input {border: 2px solid #cf3636!important;}' +
  '.cc-cvv-field {width: 30%!important;}' +
  '.country-list.show {display: block!important;}' +
  '.clearfix:before, .clearfix:after {display: table; content: " "}' +
  '.clearfix:after {clear: both}' +
  '</style>';

const applePayHeight = window.ApplePaySession ? 'min-height: 670px;' : 'min-height: 580px;';

export const styles = {
  inlineStyles,
  frmStyles: 'border: none; width: 100%; ' + applePayHeight,
  paymentFrmStyles: 'margin: 0;',
  paymentFrmInnerStyles:
    'display: flex; flex-wrap: wrap; margin-bottom: 25px; font-family: Roboto; position: relative; margin-top: 25px; min-height: 128px;',
  formGroupStyles: 'padding: 0; position: relative; margin-bottom: 25px; box-sizing: border-box;',
  errorStyles: 'margin: 0px 11px 0 14px; font-size: 12px; color: #cf3636; display: none; font-family: Roboto;',
  labelStyles:
    'color: #707070; font-size: 14px; background: #fff; position: absolute; left: 12px; top: -8px; font-family: Roboto, sans-serif; z-index: 10; padding: 0 4px; display: none;',
  inputStyles:
    '-webkit-appearance: none; -moz-appearance: none; appearance: none; box-shadow: none; position: relative; border-radius: 4px; border: 2px solid #c6c8ca; background: transparent; padding: 16px 5px 16px 14px; outline: none; color: #404040; font-family: Roboto, sans-serif; font-size: 18px; margin: 0; width: 100%; display: block; box-sizing: border-box;',
  inputCVVStyles: '-webkit-text-security: disc; -moz-webkit-text-security: disc; -moz-text-security: disc;',
  buttonsContainerStyles: 'display: none;',
  formGroupWidthThreeColumnsStyles: 'width: 40%; margin-right: 5%;',
};
